export default __webpack_public_path__ + "static/BusinessEnergy-049b31d34260cd934c3d0fd95d9a1ff7.jpeg";